var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.welcomeData.length == 0
      ? _c(
          "div",
          { staticClass: "ins_blank_imgs" },
          _vm._l(7, function(i) {
            return _c("div", { class: "ins_blank_img ins_blank_img" + (i + 1) })
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.welcomeData.length == 7
      ? _c(
          "div",
          { staticClass: "ins_blank_imgs" },
          _vm._l(_vm.welcomeData, function(item, index) {
            return _c(
              "div",
              { class: "ins_blank_img ins_blank_img" + (index + 1) },
              [
                _c("img", {
                  staticClass: "ins_blank_img_base64",
                  attrs: { draggable: "false", src: item.base64 }
                }),
                _vm._v(" "),
                item.type == 1
                  ? _c("img", {
                      staticClass: "ins_blank_img_icon",
                      attrs: {
                        draggable: "false",
                        src: require("../../assets/images/imageSaver/typeVideo.svg")
                      }
                    })
                  : _vm._e()
              ]
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a15230c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a15230c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/image_saver_welcome.vue
// module id = null
// module chunks = 